import { Navigate } from "react-router-dom";
import { hasUsableSession } from "../helpers/authSession";

type RedirectToHomeRouteProps = {
  children: React.ReactNode | any;
};

const RedirectToHomeRoute = ({ children }: RedirectToHomeRouteProps) => {
  if (hasUsableSession()) {
    return <Navigate to="/home" />;
  } else {
    return children;
  }
};

export default RedirectToHomeRoute;
